import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonsModule } from '@hiptraveler/ui/buttons';

import { SentimentAnalysisModule } from './sentiment-analysis/sentiment-analysis.module';

import { ReviewsComponent } from './reviews.component';



const MODULES = [
  CommonModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  TranslateModule
];

const LIBRARIES = [
  ButtonsModule,
  SentimentAnalysisModule
];

const COMPONENTS = [
  ReviewsComponent
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    ReviewsComponent
  ]
})
export class ReviewsModule { }
